export default __webpack_public_path__ + "static/ticket_icon-17ec48680bbc759691c554bb806b8784.png";